import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import React from 'react'
import { connect } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom-v5-compat'
import { bindActionCreators } from 'redux'

import TotpGuard from '@/app/component/guard/totp'
import Layout from '@/app/component/layout/page'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import UpdateContactForm from '@/app/module/contacts/component/form/update-contact-form'
import { updateItem } from '@/app/module/contacts/store/actions'
import Notifications from '@/app/module/notifications'

const Container = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  maxWidth: '960px',
  margin: 'auto',
}))

type ContactsItemPageProps = {
  name: string
  match: {
    url: string
    path: string
  }
  clearItem: () => void
}

function ContactsEditItemPage({ name, match, clearItem }: ContactsItemPageProps) {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams<{ contactsId: string }>()

  const onExitItem = React.useCallback(() => {
    navigate(location.state?.fromUrl || '/contacts')
  }, [location, navigate])

  React.useEffect(() => {
    return () => {
      clearItem()
    }
  }, [clearItem])

  return (
    <AuthGuard url={match.url} path={match.path}>
      <Layout title="Edit Contact - engageSPARK">
        <AuthHeader currentPage={name} />
        <TotpGuard>
          <Container>
            <Box sx={{ my: 4 }}>
              <Typography variant="h5">Edit contact</Typography>
            </Box>
            <UpdateContactForm itemId={Number(params.contactsId)} onExit={onExitItem} />
          </Container>
        </TotpGuard>
      </Layout>
      <Notifications />
    </AuthGuard>
  )
}

export default connect(
  ({ contacts }) => ({
    data: contacts.list.data,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        clearItem: () => () => {
          dispatch(updateItem({}))
        },
      },
      dispatch,
    ),
)(ContactsEditItemPage)
